import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const setNewUserById = createAsyncThunk(
  'users/setNewUserById',
  catchAsync(async (data, thunkAPI) => {
    const res = await axios.post('/users/new', data);
    return res.data;
  })
);
